module.exports = __webpack_public_path__ + "img/d4b4c37e-b76d-4bbc-80e7-97ebc4fefd61.56ce9e05.webp";